import Users from "Dashboard/Users";
import AddUser from "Dashboard/Users/AddUser";
import Companies from "pages/Auth/Companies";
import CompaniesRegister from "pages/Auth/Companies-register";
import FAQsPage from "pages/Miscellaneous/FAQsPage";
import CompaniesUpdate from "pages/Auth/Companies-update";
import ForgetPassword from "pages/Auth/ForgetPassword";
import Login from "pages/Auth/Login";
import ResetPassword from "pages/Auth/ResetPassword";
import Dashboard from "pages/Dashboard/Dashboard";
import IssueLayout from "pages/Manufacturer/MaterialStock/Issue/IssueLayout";
import MaterialList from "pages/Manufacturer/MaterialStock/MaterialList/MaterialList";
import MaterialStockLayout from "pages/Manufacturer/MaterialStock/MaterialStockLayout";
import PurchaseLayout from "pages/Manufacturer/MaterialStock/Purchase/PurchaseLayout";
import Vendors from "pages/Manufacturer/MaterialStock/Vendors/Vendors";
import AttendanceDetailsPage from "pages/Manufacturer/MUtilities/Attendance/AttDetailsPage/AttendanceDetailsPage";
import Attendance from "pages/Manufacturer/MUtilities/Attendance/Attendance";
import LossRunReport from "pages/Manufacturer/MUtilities/LossRunReport/LossRunReport";
import PkShipments from "pages/Manufacturer/MUtilities/PkShipments/PkShipments";
import WOApprovalAudit from "pages/Sales/WorkOrders/WOApprovalAudit/WOApprovalAudit";
import MPasswordManager from "pages/Manufacturer/MUtilities/MPasswordManager/MPasswordManager";
import MProductsLayout from "pages/Manufacturer/Products/MProductsLayout";
import WagesLayout from "pages/Manufacturer/Wages/WagesLayout";
import MOrders from "pages/Manufacturer/WorkOrders/MOrders";
import MoDetailsLayout from "pages/Manufacturer/WorkOrders/WWoDetails/MoDetailsLayout";
import LeadDetailsLayout from "pages/Marketing/Leads/LeadDetails/LeadDetailsLayout";
import Leads from "pages/Marketing/Leads/Leads";
import ExcelFunctions from "pages/Miscellaneous/ExcelFunctions/ExcelFunctions";
import Home from "pages/Miscellaneous/Home";
import HowToVideos from "pages/Miscellaneous/howToVideos/HowToVideos";
import LandingPage from "pages/Miscellaneous/LandingPage";
import ContactUs from "pages/Miscellaneous/ContactUs";
import PriceCalculator from "pages/Miscellaneous/PriceCalculator/PriceCalculator";
import ShipmentLabel from "pages/Miscellaneous/ShipmentLabel copy";
import TestComponents from "pages/Miscellaneous/TestComponents";
import Tracking from "pages/Miscellaneous/Tracking";
import NoMatch from "pages/NoMatch";
import PasswordManager from "pages/PasswordManager/PasswordManager";
import WorkOrdersPdf from "pages/PdfTesting";
import ApprovalProducts from "pages/Sales/ApprovalProducts/ApprovalProducts";
import Approvals from "pages/Sales/Approvals/Approvals";
import Purchasing from "pages/Sales/Purchasing/Purchasing";
import UpsTracking from "pages/Sales/UpsTracking/UpsTracking";
import { canUseShipments } from "pages/Sales/UpsTracking/permission";
import NovaShipping from "pages/Sales/NovaShipping/NovaShipping";
import Customers from "pages/Sales/Customers/Customers";
import CustomerDetailsLayout from "pages/Sales/Customers/CutomerDetails/CustomerDetailsLayout";
import JobBoard from "pages/Sales/JobBoard/JobBoard";
import StationBoard from "pages/Sales/StationBoard/StationBoard";
import TempEmbroideryBoard from "pages/Sales/JobBoard/Others/TempEmbroideryBoard";
import Quote from "pages/Sales/Quote/Quote";
import QuoteDetailsPage from "pages/Sales/Quote/QuoteDetails/QuoteDetailsPage";
import ShipmentDetailsLayout from "pages/Sales/Shipments/ShipmentDetails/ShipmentDetailsLayout";
import LabelPrinter from "pages/Sales/SUtilities/LabelPrinter/LabelPrinter";
import OrderSheet from "pages/Sales/SUtilities/OrderSheet/OrderSheet";
import SProductsLayout from "pages/Sales/SUtilities/Products/SProductsLayout";
import WorkflowBuilder from "pages/Sales/SUtilities/Products/Workflows/WorkflowBuilder";
import Reports from "pages/Sales/SUtilities/Reports/Reports";
import Electron from "pages/Sales/WorkOrders/Electron/electron";
import DetailsPage from "pages/Sales/WorkOrders/WorkOrderDetails/detailsPage";
import CustomerWoApproval from "pages/Sales/WorkOrders/WorkOrderDetails/LotApproval/CustomerWoApproval";
import RecordVideoTest from "pages/Test/VideoRecordTest/RecordVideoTest";
import TestVideos from "pages/Test/VideoRecordTest/TestVideos";
import ArtManagerTest from "pages/ArtManager/ArtManagerTest";
import WorkOrders from "pages/Sales/WorkOrders/WorkOrders";
import SaveGrant from "pages/settings/EmailClient/EmailAuth/SaveGrant";
import HandheldUpdates from "pages/settings/HandheldUpdates/HandheldUpdates";
import Settings from "pages/settings/Settings";
import WebHook from "pages/settings/Webhooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import ProtectedRoute from "routing/ProtectedRoute";
import { VersionProvider } from "./features/Contexts/VersionContext";

import Register from "pages/Auth/Signup";
import PayBookLayout from "pages/Manufacturer/Accounts/PayBook/PayBookLayout";
import AnalysisCard from "pages/Manufacturer/Efs/AnalysisCard/AnalysisCard";
import EfsInvDetailsLayout from "pages/Manufacturer/Efs/EfsInvoice/EfsInvDetailsLayout";
import EfsInvoice from "pages/Manufacturer/Efs/EfsInvoice/EfsInvoice";
import { EfsInvoiceProvider } from "pages/Manufacturer/Efs/EfsInvoice/EfsInvoiceContext";
import EfsLayout from "pages/Manufacturer/Efs/EfsLayout";
import EmailsLayout from "pages/Sales/Inbox/EmailsLayout";
import "./App.scss";
import FeaturesPage from "pages/Miscellaneous/FeaturesPage";

function usePlainCopy() {
  useEffect(() => {
    const handleCopy = (e) => {
      const sel = window.getSelection();
      if (!sel) return;

      const plain = sel.toString();
      if (!plain) return;

      e.preventDefault();

      if (e.clipboardData) {
        e.clipboardData.setData("text/plain", plain);
        e.clipboardData.setData("text/html", plain); // stops Gmail from using styled HTML
      } else if (window.clipboardData) {
        window.clipboardData.setData("Text", plain);
      }
    };

    document.addEventListener("copy", handleCopy);
    return () => {
      document.removeEventListener("copy", handleCopy);
    };
  }, []);
}

function App() {
  const { userInfo } = useSelector((state) => state.user);
  usePlainCopy();

  useEffect(() => {
    if (!userInfo) {
      // document.body.classList.add('authentication-bg')
    } else {
      document.body.classList.remove("authentication-bg");
    }
  }, [userInfo]);

  return (
    // <>
    //   <h1 className="flex-center h-full">Website Under Maintenance</h1>
    // </>
    <VersionProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/contact-us" element={<ContactUs />} />

          <Route path="/login" element={<Home />} />
          <Route path="/app/client-login" element={<Login />} />
          {/* <Route path="/customer-login" element={<CustomerLogin />} /> */}
          <Route path="/signup" element={<Register />} />
          {/* <Route path="/mockups/:token" element={<ArtApproval />} /> */}
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Customer Wo Approval */}
          <Route
            path="/work-order/approvals/:companyId/:token"
            element={<CustomerWoApproval />}
          />

          {/* Public video-record test (mobile) */}
          <Route path="/test/record/:token" element={<RecordVideoTest />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/test/videos" element={<TestVideos />} />
            <Route path="/art-manager/test" element={<ArtManagerTest />} />
            <Route path="/379372b46gab2ukw" element={<WebHook />} />

            <Route path="/password-manager" element={<PasswordManager />} />

            <Route path="/user-management" element={<Users />} />
            <Route path="/user-management/add" element={<AddUser />} />
            <Route path="/user-management/add/:id" element={<AddUser />} />

            <Route path="/user-management" element={<Users />} />
            <Route path="/user-management/add" element={<AddUser />} />
            <Route path="/user-management/add/:id" element={<AddUser />} />

            {/*   Marketing
             ********************************************* */}
            <Route path="/marketing/leads" element={<Leads />} />
            <Route
              path="/lead/details/:selectedID"
              element={<LeadDetailsLayout />}
            />

            {/*   Sales
             ********************************************* */}

            <Route path="/customer" element={<Customers />} />
            <Route
              path="/customer/details/:selectedID"
              element={<CustomerDetailsLayout />}
            />
            <Route path="/quotes/:filterBy" element={<Quote />} />
            <Route
              path="/quotes/details/:filterBy/:selectedID"
              element={<QuoteDetailsPage />}
            />
            <Route
              path="/work-orders/:filterBy"
              element={
                userInfo?.roles !== "customer" ? <WorkOrders /> : <NoMatch />
              }
            />
            <Route
              path="/work-order/details/:filterBy/:selectedID"
              element={<DetailsPage />}
            />
            <Route path="/work-orders" element={<WorkOrders />} />

            <Route path="/sales/wo-approvals" element={<Approvals />} />
            <Route path="/sales/purchasing" element={<Purchasing />} />
            {/* Tracking Info (was Ups Tracking, 2026-10-15). The old address
                redirects so bookmarks keep working. */}
            {/* Sales -> Shipments permission (2026-10-21): without it the
                address goes to the dashboard rather than a page whose every
                request the API would refuse. */}
            <Route
              path="/sales/tracking-info"
              element={
                canUseShipments(userInfo) ? (
                  <UpsTracking />
                ) : (
                  <Navigate to="/dashboard" replace />
                )
              }
            />
            <Route
              path="/sales/ups-tracking"
              element={<Navigate to="/sales/tracking-info" replace />}
            />
            <Route path="/sales/nova-shipping" element={<NovaShipping />} />

            <Route
              path="/sales/shipments/details"
              element={<ShipmentDetailsLayout />}
            />

            {/*   Sales Utility Routes
             *************************** */}
            <Route
              path="/sales/approval-products"
              element={<ApprovalProducts />}
            />
            <Route path="/label-printer" element={<LabelPrinter />} />
            <Route path="/order-sheet" element={<OrderSheet />} />

            <Route path="/sales/products" element={<SProductsLayout />} />
            <Route
              path="/sales/products/workflow/:id"
              element={<WorkflowBuilder />}
            />
            <Route path="sales/reports" element={<Reports />} />
            <Route path="/shipment-label" element={<ShipmentLabel />} />
            <Route path="email/inbox" element={<EmailsLayout />} />
            {/* <Route path="email/get/url" element={<GetNylasAuth />} /> */}
            <Route path="email/oauth/exchange" element={<SaveGrant />} />

            {/*   Manufacturing
             ********************************************* */}
            <Route path="manufacturer/vendors" element={<Vendors />} />
            <Route path="manufacturer/m-orders" element={<MOrders />} />
            <Route path="manufacturer/wages" element={<WagesLayout />} />
            <Route
              path="manufacturer/m-orders/details/:m_woId"
              element={<MoDetailsLayout />}
            />

            <Route
              path="manufacturer/material-stock"
              element={<MaterialStockLayout />}
            />
            <Route
              path="manufacturer/material-stock/manufacturer-material-list"
              element={<MaterialList />}
            />
            <Route
              path="manufacturer/material-stock/material-purchase"
              element={<PurchaseLayout />}
            />
            <Route
              path="manufacturer/material-stock/material-issue"
              element={<IssueLayout />}
            />

            {/* Efs Invoice */}
            <Route path="manufacturer/efs-imports" element={<EfsLayout />} />

            {/* EFS Analysis Card */}
            <Route
              path="manufacturer/efs-analysis-card"
              element={<AnalysisCard />}
            />

            {/* Efs Invoice */}
            <Route path="manufacturer/efs-invoice" element={<EfsInvoice />} />

            <Route
              path="manufacturer/efs-invoice/details/:invId"
              element={
                <EfsInvoiceProvider>
                  <EfsInvDetailsLayout />
                </EfsInvoiceProvider>
              }
            />

            {/* Accounts */}
            {userInfo?.permissions?.includes("m_day_book") ||
            userInfo?.roles === "admin" ? (
              <Route
                path="manufacturer/accounts/pay-book"
                element={<PayBookLayout />}
              />
            ) : null}

            <Route path="manufacturer/products" element={<MProductsLayout />} />

            {/*   Manufacturing Utility Routes
             ********************************************* */}
            <Route path="/m-passwords" element={<MPasswordManager />} />

            <Route path="/attendance" element={<Attendance />} />
            <Route
              path="/attendance/user/:deviceId/:userId"
              element={<AttendanceDetailsPage />}
            />

            <Route
              path="manufacturer/loss-run-report"
              element={<LossRunReport />}
            />
            <Route
              path="manufacturer/pk-shipments"
              element={<PkShipments />}
            />

            <Route
              path="sales/wo-approval-audit"
              element={<WOApprovalAudit />}
            />

            {/*  Miscellaneous Utility Routes
             ********************************************* */}

            <Route path="/pdf-test" element={<WorkOrdersPdf />} />
            <Route path="/excel-functions" element={<ExcelFunctions />} />
            <Route path="/tracking" element={<Tracking />} />
            <Route path="/status-board" element={<JobBoard />} />
            <Route path="/station-board" element={<StationBoard />} />
            {/* Pending Invoices page, Job Board tab (user, 2026-10-29). */}
            <Route path="/pending-invoices/job-board" element={<JobBoard invoiceOnly />} />
            <Route
              path="/status-board/temp-embroidery"
              element={
                userInfo?.roles === "admin" ||
                userInfo?.permissions?.includes("temp_dashboard") ? (
                  <TempEmbroideryBoard />
                ) : (
                  <NoMatch />
                )
              }
            />
            <Route path="/how-to-videos" element={<HowToVideos />} />

            <Route path="/price-calculator" element={<PriceCalculator />} />

            <Route path="/electron-test" element={<Electron />} />

            {/* Customer Portal Routes */}
            {/* <Route
              path="/portal/:company/work-order"
              element={
                userInfo?.roles === "customer" ? (
                  <PortalWorkOrder />
                ) : (
                  <NoMatch />
                )
              }
            /> */}

            {/* Admin Routes */}
            <Route path="/settings" element={<Settings />} />
            {/* The page hides itself when /rfid-publish/state answers 403, so
                the route itself does not need a permission gate. */}
            <Route
              path="/settings/handheld-updates"
              element={<HandheldUpdates />}
            />
            <Route path="/companies" element={<Companies />} />
            <Route path="/companies/register" element={<CompaniesRegister />} />
            <Route
              path="/companies/update/:companyID"
              element={<CompaniesUpdate />}
            />

            {/*   Testing Routes
             ********************************************* */}
            <Route path="/testing-components" element={<TestComponents />} />

            <Route path="*" element={<NoMatch />} />
          </Route>

          <Route path="*" element={<LandingPage />} />
        </Routes>
      </Router>
    </VersionProvider>
  );
}

export default App;
